import React, { useEffect, useState } from 'react';
import ServiceBox from '../ServiceBox/ServiceBox';
import { serviceEndpoint } from '../../../variables/services'
import SearchBar from '../../../components/SearchBar/SearchBar'
import NewService from './NewService/NewService';
import Service from '../Service/Service';

import './Services-new.css'
import Catalog from '../../../components/catalog/Catalog';
import TaskRunning from '../../../components/taskRunning/TaskRunning';
import StatusPage from '../../../components/taskRunning/statusPage/StatusPage';

const Services = ({ projectId, select=false, selectService=()=>{}, exclude=[]}) => {
    
    const [services, setServices] = useState([]);
    const [currentPage, setCurrentPage] = useState("main");
    const [filter, setFilter] = useState("");
    const [editObj, setEditObj] = useState() ;
    const [selectedService, setSelectedService] = useState({});
    const [taskId, setTaskId] = useState()


    const deleteService = (service_id) => {
        setCurrentPage("taskRunning")
        const queryParams = new URLSearchParams({id: service_id}).toString();
        fetch(`${serviceEndpoint}/service?${queryParams}`, {
            method: "DELETE",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            })
            .then(res => {
            if (!res.ok) { 
                return res.json().then(data => {
                throw new Error("Error: " + (data.message || "Unknown error")); // Handle API error messages
                });
            }
            return res.json(); // Only parse JSON if response is OK (200)
            })
            .then(data => {
                setTaskId(data["task_id"])
            })
            .catch(error => {
            // setError(error.message); // Store error message in state
                console.error("Error deleting service:", error);
            });
    }

    return (
        <div className='service-page'>
                {currentPage === "main" && (
                    <Catalog exclude={exclude} fetchUrl={`${serviceEndpoint}/services`}
                    fetchArgs = {{project_id: projectId}}
                    goToNewObject={()=>{setCurrentPage("newService")}}
                    catalogBox={(service)=>{return (
                        <ServiceBox goToService={()=>{
                            if (select)
                                selectService(service);
                            else
                                setCurrentPage("service");
                        }} selecteService={setSelectedService} serviceInfo={service}
                        goToDelete={()=>{
                            setCurrentPage("deleteService");
                            setSelectedService(service);
                        }}/>
                    )}}
                    />
                 )}
                {currentPage === "newService" && <NewService projectId={projectId} exit={()=>{setCurrentPage("main")}}/>}
                {currentPage === "service" && <Service exit={()=>{setCurrentPage("main")}} service={selectedService} />}
                {currentPage === "edit" && editObj}
                {currentPage === "deleteService" && <div className='delete-service'>
                        <label>{`Are Sure you want to delete service ${selectedService.service_name}?`}</label>
                        <div className='buttons'>
                            <button className='delete' onClick={()=>{deleteService(selectedService.id)}}>Delete</button>
                            <button className='cancel' onClick={()=>setCurrentPage("main")}>Cancel</button>
                        </div>
                    </div>}
                {currentPage === "taskRunning" && <TaskRunning taskId={taskId} done={()=>{setCurrentPage("statusPage")}} className="sized-page"/>}
                {currentPage === "statusPage" && <StatusPage taskId={taskId} exit={()=>{setCurrentPage("main")}} className="sized-page" successMessage="Service Deleted Successfully!" failureMessage="Failed to delete service"/>}
        </div>
    );
};

export default Services;